import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const REVIEWS = [
  { name: 'Marco R.', text: 'Servizio impeccabile! Locker puliti e sicuri. Perfetto vicino alla stazione.', rating: 5 },
  { name: 'Sarah M.', text: 'Super easy to use! Left my bags and explored Naples freely.', rating: 5 },
  { name: 'Giuseppe L.', text: 'Finalmente un servizio moderno a Napoli. Prezzi onesti e sistema veloce.', rating: 5 },
  { name: 'Emma K.', text: 'The automated system is brilliant. No queues, no hassle. Highly recommend!', rating: 5 },
];

const ReviewsSection = () => {
  return (
    <section className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#141414] overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <span className="text-[#FFCC00] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
            Recensioni
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Cosa dicono i nostri clienti
          </h2>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={`review-header-star-${i}`} className="w-6 h-6 fill-[#FFCC00] text-[#FFCC00]" />
            ))}
          </div>
          <p className="text-gray-400">4.9/5 basato su 500+ recensioni</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {REVIEWS.map((review, index) => (
            <motion.div
              key={`review-${review.name}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-[#0A0A0A] border border-[#2A2A2A] p-6"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={`review-${review.name}-star-${i}`} className="w-4 h-4 fill-[#FFCC00] text-[#FFCC00]" />
                ))}
              </div>
              <p className="text-gray-300 mb-4 text-sm leading-relaxed">
                &ldquo;{review.text}&rdquo;
              </p>
              <p className="text-white font-semibold text-sm">
                {review.name}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
